module.exports = __webpack_public_path__ + "img/Zöpfe.ffd57c9e.svg";